import React, {
  createContext,
  useState,
  useEffect,
  PropsWithChildren,
} from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import {
  AppMessages,
  getLanguage,
  getMessages,
  DefaultLanguage,
  Language,
} from '../core/localization';
import { LocaleCtxProvider } from './locale.context';
import { ReduxState } from '../interfaces';
import Logger from '../libs/logger';   
import { LogArea } from '../libs/logger/const';

export const LanguageCtx = createContext({});
type StateProps = {
  langcode: string;
};

type Props = PropsWithChildren<StateProps>;

export const LanguageCtxProviderBase = (props: Props) => {
  const [language, setLanguage] = useState({
    code: props.langcode,
  } as Language);
  const [messages, setMessages] = useState(AppMessages);
  const [langToLoad, setLangToLoad] = useState([] as Language[]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setLangToLoad([DefaultLanguage]);
  }, []);

  useEffect(() => {
    const lang = getLanguage(props.langcode);
    if (lang.code === language.code) return;
    setLangToLoad([lang]);
  }, [language.code, props.langcode]);

  if (!isLoading && langToLoad.length) {
    const lang = langToLoad[langToLoad.length - 1];
    if (lang.code !== language.code) {
      setIsLoading(true);
      setLanguage(lang);
      Logger.info(['Loading language', lang], LogArea.Localization);
      setLangToLoad([]);
      getMessages(lang).then((data) => {
        setMessages(data);
        setIsLoading(false);
      });
    } else {
      setLangToLoad(langToLoad.slice(0, langToLoad.length - 1));
    }
  }

  return (
    <IntlProvider locale={language.code} messages={messages}>
      <LocaleCtxProvider>{props.children}</LocaleCtxProvider>
    </IntlProvider>
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  langcode: state.localizationState.lang || 'en',
});

export const LanguageCtxProvider = connect(mapStateToProps)(
  LanguageCtxProviderBase
);
